import React, { useState } from "react";
import { useAxiosInstance } from "@/utils/useAxiosInstance";
import { useTranslation } from "react-i18next";

interface Transaction {
  id: number;
  amount: string;
}

interface TransactionVoidPopupProps {
  transaction: Transaction;
  onClose: () => void;
  onVoidComplete: () => void;
}

const TransactionVoidPopup: React.FC<TransactionVoidPopupProps> = ({
  transaction,
  onClose,
  onVoidComplete,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [axiosInstance] = useAxiosInstance();
  const { t } = useTranslation();

  const handleVoid = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(
        `api/v1/transaction/${transaction.id}/void/`,
      );

      if (response.status === 200) {
        onVoidComplete();
      }
    } catch (error) {
      console.error("Error voiding transaction:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="h-auto w-full max-w-lg rounded-lg bg-white p-4 shadow-lg">
        <h2 className="overflow-wrap break-word max-w-full whitespace-normal text-center text-lg font-bold">
          {t("back.management.transaction.confirmVoid")}
        </h2>
        <p className="mt-4 text-center">
          {t("back.management.transaction.voidAmount")}: ${transaction.amount}
        </p>
        <div className="mt-4 flex justify-end">
          <button
            className="mr-2 rounded bg-red-500 px-4 py-2 text-white disabled:opacity-50"
            onClick={handleVoid}
            disabled={isLoading}
          >
            {isLoading
              ? t("back.management.transaction.processing")
              : t("back.management.transaction.confirm")}
          </button>
          <button
            className="rounded bg-gray-400 px-4 py-2 text-white"
            onClick={onClose}
          >
            {t("back.management.transaction.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionVoidPopup;
